import React, { Component } from "react";
import Avatar from './darkpatterns2d/Avatar';

class RoundStartText extends Component {
	constructor(props) {
		super(props);

		this.state = {
			subText: props.duration,
			timerKey : undefined
		};
		
		this.countDown = () => {

			const subText = this.state.subText;
			const key = setTimeout( () => {
				
				const newsubText = subText - 1;

				if(newsubText >= 1)
					this.props.playSndFx('threeDCountdown');
				else
					this.props.playSndFx('threeDCountdownComplete');

				this.setState({ subText: newsubText < 1 ? "GO!" : newsubText });
				if( newsubText > 0 ){
					this.countDown()
				}else{
					this.props.callback()
				}

			}, 1000 );
			this.setState({ timerKey : key });
		}
	}
	componentDidMount() {
		const key = setTimeout( () => {
			this.countDown();
		}, 1000 );
		this.setState({ timerKey : key });
	}

	componentWillUnmount() {
		clearTimeout(this.state.timerKey)
	}

	render() {
		let animationStyles = {
			animationDuration: `${this.props.duration + 1}s`
		};
		return (
			<div className="game-placard-wrapper" style={animationStyles}>
				<div className="game-placard" style={animationStyles}>
					<div className="inner-game-placard">
						<div className="avatar3dintro">
							<Avatar round={this.props.round} look={3} speaking={false} className="avatarIcon"/>
							<div className="avatarSays">{this.props.introBubble}</div>	
						</div>
						<div className="ragecountdown">
							<div className="info">{this.props.introPrompt}</div>
							<div className={`subText jump-${this.state.subText}`}>{this.state.subText}</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default RoundStartText;



// WEBPACK FOOTER //
// ./src/components/RoundStartText.js